// libs
import styled from "styled-components";
// theme
import { typography, colors } from "src/theme";
// const
import devices from "src/constants/media";

export const WrongMessage = styled.div`
  display: flex;
  flex-direction: column;
`;
export const ImageContainer = styled.div`
  width: 48px;
  height: 48px;
`;
export const Title = styled.p`
  margin-top: 32px;
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  color: ${colors.greyDark};
`;
export const Subtitle = styled.p`
  margin-top: 4px;
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: ${colors.grey};

  @media ${devices.tablet} {
    padding-right: 24px;
  }
`;
export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  margin-top: 56px;

  @media ${devices.tablet} {
    flex-direction: row;
    justify-content: flex-end;
    margin-top: 32px;
  }
`;
export const ButtonBox = styled.div`
  @media ${devices.tablet} {
    width: 106px;
  }
`;
export const ButtonBoxCancel = styled.div`
  margin-top: 12px;

  @media ${devices.tablet} {
    width: 90px;
    margin-right: 12px;
    margin-top: 0;
  }
`;
